module.exports = __webpack_public_path__ + "img/shopping.692fb1a6.png";